// src/Pages/PortfolioPage.js
import React from 'react';
import PortfolioItem from '../Components/PortfolioItem'; // New component import

const portfolioItems = {
  products: [
    {
      title: 'Mobile Applications',
      description: 'We develop custom mobile applications for various platforms, including iOS and Android, focusing on seamless user experience and performance.',
      imageUrl: './images/Portfolio/DeliveryMobileApp.png',
      tags: ['Mobile', 'iOS', 'Android', 'Custom Development'],
    },
    {
      title: 'NeatTV Live TV Application',
      description: 'A dedicated live television application designed for a streamlined, high-quality viewing experience with a wide range of channels and features.',
      imageUrl: './images/Portfolio/neatTV.png',
      tags: ['Media', 'Streaming', 'TV', 'Software Product'],
    },
  ],
  projects: [
    {
      title: 'HK Metrology',
      description: 'A metrology service website for a company in Canada, showcasing their precise measurement and calibration services.',
      imageUrl: './images/Portfolio/hkmetrology.png',
      linkUrl: 'https://www.hkmetrology.com',
      tags: ['Website', 'Canada', 'Metrology'],
    },
    {
      title: 'Gujju Foodz',
      description: 'An e-commerce website for an Indian snacks business in Qatar, allowing customers to easily browse and order products online.',
      imageUrl: './images/Portfolio/GujjuFoodz.png',
      linkUrl: 'https://gujjufoodz.com/',
      tags: ['E-commerce', 'Qatar', 'Food', 'Website'],
    },
    {
      title: 'Flyinfy',
      description: 'A web platform for a visa and immigration service based in India, providing detailed information and a streamlined application process.',
      imageUrl: './images/Portfolio/Flyinfy.png',
      linkUrl: 'https://flyinfy.com/',
      tags: ['Website', 'India', 'Immigration'],
    },
    {
      title: 'MyBazaar',
      description: 'A food delivery service platform where customers can choose food from various restaurants with a single delivery option.',
      imageUrl: 'https://placehold.co/600x400/EC4899/FFFFFF?text=MyBazzar.ge',
      linkUrl: 'https://www.MyBazzar.ge',
      tags: ['Website', 'Delivery', 'Multi-vendor'],
    },
    {
      title: 'Nira Design and Fashion',
      description: 'A website for a design and fashion business, showcasing their unique collections and services.',
      imageUrl: 'https://placehold.co/600x400/F97316/FFFFFF?text=Nira+Design+Fashion',
      linkUrl: 'https://NiraDesignAndFashion.com/',
      tags: ['Website', 'Fashion', 'Design'],
    },
    {
      title: 'Sher E Punjab',
      description: 'A website for a restaurant, providing a digital presence to showcase their menu and location.',
      imageUrl: './images/Portfolio/SherEPunjab.png',
      linkUrl: 'http://celeritytec.com',
      tags: ['Website', 'Restaurant', 'Hospitality'],
    },
  ],
};

const PortfolioPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-10 drop-shadow-sm">Our Portfolio</h2>
        <p className="text-lg text-gray-700 text-center mb-12 max-w-3xl mx-auto">
          We are proud to showcase a few of our successful projects and innovative products, demonstrating our commitment to quality and technical excellence.
        </p>

        {/* Products Section */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-800 border-b-2 border-gray-300 pb-4 mb-8">Our Products</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolioItems.products.map((item, index) => (
              <PortfolioItem key={index} {...item} />
            ))}
          </div>
        </div>

        {/* Projects Section */}
        <div>
          <h3 className="text-3xl font-bold text-gray-800 border-b-2 border-gray-300 pb-4 mb-8">Client Projects</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolioItems.projects.map((item, index) => (
              <PortfolioItem key={index} {...item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;